import React from 'react';
import DateTimePickerWrapper from '../../../../../../DateTimePickerWrapper/DateTimePickerWrapper';

const EventDatePickers = ({
  startDate,
  endDate,
  openStartPicker,
  openEndPicker,
  handleStartDateChange,
  handleEndDateChange,
  setOpenStartPicker,
  setOpenEndPicker,
  size = 'large',
}) => {
  return (
    <>
      <DateTimePickerWrapper
        label="Start Date"
        value={startDate}
        open={openStartPicker}
        onOpen={() => setOpenStartPicker(true)}
        onClose={() => setOpenStartPicker(false)}
        onChange={handleStartDateChange}
        size={size}
        pickerType="date"
      />
      <DateTimePickerWrapper
        label="End Date"
        value={endDate}
        open={openEndPicker}
        onOpen={() => setOpenEndPicker(true)}
        onClose={() => setOpenEndPicker(false)}
        onChange={handleEndDateChange}
        size={size}
        pickerType="date"
      />
    </>
  );
};

export default EventDatePickers;
